import type { JSX } from "react";
import { NavLink, useLocation } from "react-router";
import { primaryNavItems } from "./navItems.js";
import { useKeyboardOpen } from "./useKeyboardOpen.js";

export function BottomTabBar(): JSX.Element | null {
  const { pathname } = useLocation();
  const keyboardOpen = useKeyboardOpen();
  if (pathname.startsWith("/cook/") || keyboardOpen) return null;
  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-zinc-800 bg-zinc-950/95 backdrop-blur pb-safe md:hidden"
    >
      <ul className="flex">
        {primaryNavItems.map((item) => (
          <li key={item.id} className="flex-1">
            <NavLink
              to={item.path}
              end={item.path === "/"}
              className={({ isActive }) =>
                `flex min-h-12 flex-col items-center justify-center gap-0.5 py-1.5 text-[11px] ${isActive ? "text-emerald-400" : "text-zinc-400"}`
              }
            >
              <item.icon className="size-5" aria-hidden />
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
